"use client";

import { Hand, Leaf, Waves, Wind } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const principles = [{
  icon: Leaf,
  number: "01 · SKILLS",
  title: "Building Skills",
  description: "There are so many common needs for skills across small charities, for example marketing & social media outreach. Young adults have unique insight into new customers and ways to reach them. Any charity can create placements to provide young people with valuable expertise, as long as both parties are committed to delivering on the opportunity created."
}, {
  icon: Wind,
  number: "02 · DEVELOPMENT",
  title: "Creating Shared Value",
  description: "There are 900,000 young people without a job. Delaying the provision of relevant work experience that inspires them will have negative impacts on both mental health and self confidence in life. On the other hand, creating opportunities for work experience will accelerate the opportunity for future talent.\xA0"
}, {
  icon: Hand,
  number: "03 · AFFINITY",
  title: "The power of Affinity",
  description: "One successful outcome leads to another. A charity with a good experience will create more placement opportunities – and young people with jobs fuel the future economy. A charity can offer targeted work experience to those young people aligned to the community that it supports – creating a virtuous circle."
}, {
  icon: Waves,
  number: "04 · IMPACT",
  title: "Evidence-Based Growth",
  description: "Every project should deliver measurable value to both the organisation and the young person"
}];
function PrincipleColumn({
  principle,
  index
}: {
  principle: (typeof principles)[number];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const Icon = principle.icon;
  return <div ref={ref} data-index={index} className="relative px-6 py-10 md:px-8 md:py-0 transition-all duration-700 ease-out" style={{
    transitionDelay: `${index * 120}ms`,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(24px)"
  }}>
      <Icon className="size-12 mb-8 stroke-[1] text-sky-500" aria-hidden="true" />
      <div className="text-[11px] tracking-[0.18em] uppercase text-slate-500 mb-5 font-default">
        {principle.number}
      </div>
      <h3 className="font-serif font-default text-[26px] leading-tight text-slate-900 mb-5">
        {principle.title}
      </h3>
      <p className="text-[15px] leading-relaxed text-slate-600 font-default">
        {principle.description}
      </p>
    </div>;
}
export default function CoreValues() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2744" id="our-core-values" className="bg-white py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div ref={headerRef} className="text-center max-w-4xl mx-auto mb-20 md:mb-28 transition-all duration-700 ease-out" style={{
        opacity: headerVisible ? 1 : 0,
        transform: headerVisible ? "translateY(0)" : "translateY(24px)"
      }}>
          
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[64px] leading-[1.05] text-slate-900"></h2>
        </div>

        <div className="bg-slate-50 rounded-lg shadow-sm">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-slate-200">
            {principles.map((principle, i) => <div key={principle.title} data-index={i} className={i >= 2 ? "sm:border-t sm:border-slate-200 lg:border-t-0" : ""}>
                <PrincipleColumn principle={principle} index={i} />
              </div>)}
          </div>
        </div>
      </div>

      <div ref={imageRef} className="mt-20 md:mt-28 lg:mt-32 transition-all duration-1000 ease-out" style={{
      opacity: imageVisible ? 1 : 0,
      transform: imageVisible ? "translateY(0)" : "translateY(32px)"
    }}>
        
        <div className="max-w-7xl mx-auto px-6 md:px-10 mt-6">
          
        </div>
      </div>
    </section>;
}